/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useMemo } from "react";

import { useClient, useQuery } from "jsonapi-react";
import DataTable from "react-data-table-component";
import axios from "axios";
import noPreview from "../../assets/images/nopreview.png";
import moment from "moment-timezone";
import { apiRoutes, APP_TIMEZONE, reportDateFormat } from "../../constants";
import { DEVICE_SERVICE_URL } from "../../constants";
import LPREventReportFilter from "../../components/common/ReportFilter/LPREventReportFilter";
import ProfileCard from "../../components/ProfileCard/ProfileCard";

import useState from "react-usestateref";
import { CiCreditCard1 } from "react-icons/ci";

import ModalComponent from "../../components/common/ModalComponent/ModalComponent";
import ReactTooltip from "react-tooltip";
import {
  formatTextWithFallback,
  getFormattedDateTime,
} from "../../helpers/helpers";
import useStorage from "../../helpers/useStorage";
import {
  defaultFromDateFilterValue,
  defaultOldFromDateFilterValue,
  defaultOldToDateFilterValue,
  defaultToDateFilterValue,
  eventTypeMapper,
  getFilterDateRange,
} from "../../helpers/utils";
const LPRTransactionReport = () => {
  const { setToStorage, getFromStorage, removeFromStorage } = useStorage();
  const [isLoading, setIsLoading] = React.useState(true);
  const userTimezone = localStorage.getItem("userTz");
  const [currentPageNumber, setCurrentPageNumber] = React.useState(1);
  const [updateKey, setUpdateKey] = React.useState(0);
  const [resetPagination, setResetPagination] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(
    getFromStorage("lpr_report_rows_per_page") ?? 10
  );
  const [showDialog, setShowDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState(null);
  const [dialogTitle, setDialogTitle] = useState(null);
  const [totalEntries, setTotalEntries] = React.useState(0);
  const [searchQueryString, setSearchQueryString] = useState(
    getFromStorage("lpr_report_filter_search") ?? ""
  );
  const [eventType, setEventType] = useState(
    getFromStorage("lpr_report_filter_event_type")?.value ?? ""
  );
  const [exportData, setExportData] = useState({ page: "lpr" });

  const [crossTimeFrom, setcrossTimeFrom] = React.useState(null);
  const [crossTimeTo, setcrossTimeTo] = React.useState(null);
  const [lprReport, setlprReport] = React.useState([]);
  const token = localStorage.getItem("access_token");
  const client = useClient();
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState("");
  const [disableExport, setdisableExport] = React.useState(true);
  const [showMobileDataFilter, setShowMobileDataFilter] = React.useState(false);
  const [tab, setTab] = useState("new");
  const [filterResetKey, setFilterResetKey] = useState(0);

  const handleTabChange = (newTab) => {
    setTab(newTab);
    setSearchQueryString("");
    setEventType("");
    setFilterResetKey((prev) => prev + 1);
    setCurrentPageNumber(1);
    setResetPagination((prev) => !prev);

    if (filterDateRange?.data) {
      let dateRange;
      if (newTab === "old") {
        dateRange = getFilterDateRange(
          filterDateRange.data.retentionValue,
          filterDateRange.data.retentionUnit,
          reportDateFormat,
          true
        );
      } else {
        dateRange = getFilterDateRange(
          filterDateRange.data.defaultDurationValue,
          filterDateRange.data.defaultDurationUnit
        );
      }
      setcrossTimeFrom(dateRange.from);
      setcrossTimeTo(dateRange.to);
    }
  };

  client.config.headers = {
    Authorization: `JWT ${token}`,
  };

  const axiosOptions = (method, url) => {
    return {
      method,
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: `JWT ${token}`,
      },
      url: `${DEVICE_SERVICE_URL}/${url}`,
    };
  };

  const filterDateRange = useQuery([apiRoutes.acsDateSettings], { client });

  useEffect(() => {
    let dateRange;
    if (crossTimeFrom && crossTimeTo) return;
    if (!filterDateRange?.data) return;
    if (tab === "old") {
      dateRange = getFilterDateRange(
        filterDateRange?.data?.retentionValue,
        filterDateRange?.data?.retentionUnit,
        reportDateFormat,
        true
      );
    } else {
      dateRange = getFilterDateRange(
        filterDateRange?.data?.defaultDurationValue,
        filterDateRange?.data?.defaultDurationUnit
      );
    }
    setcrossTimeFrom(dateRange?.from);
    setcrossTimeTo(dateRange?.to);
  }, [filterDateRange?.data]);

  const onResetInitiated = (t) => {
    let dateRange;
    if (t === "old") {
      dateRange = getFilterDateRange(
        filterDateRange?.data?.retentionValue,
        filterDateRange?.data?.retentionUnit,
        reportDateFormat,
        true
      );
    } else {
      dateRange = getFilterDateRange(
        filterDateRange?.data?.defaultDurationValue,
        filterDateRange?.data?.defaultDurationUnit
      );
    }
    setcrossTimeFrom(dateRange?.from);
    setcrossTimeTo(dateRange?.to);
    setCurrentPageNumber(1);
    setEventType("");
    setResetPagination(true);
    setSearchQueryString("");
    removeFromStorage();
  };

  const handleUpdateKey = () => {
    setUpdateKey((k) => k + 1);
  };
  React.useEffect(() => {
    if (lprReport?.length > 0) {
      setdisableExport(false);
    } else {
      setdisableExport(true);
    }
  }, [lprReport]);

  const doFilter = () => {
    setIsLoading(true);
    setResetPagination(false);
    let filterItems = {
      search: searchQueryString ?? "",
      event_type:
        eventType !== undefined && eventType !== null ? eventType : "",
      cross_time_from:
        crossTimeFrom === ""
          ? ""
          : moment
              .tz(crossTimeFrom, reportDateFormat, userTimezone)
              .utc()
              .format("YYYY-MM-DD HH:mm:ss"),
      cross_time_to:
        crossTimeTo === ""
          ? ""
          : moment
              .tz(crossTimeTo, reportDateFormat, userTimezone)
              .utc()
              .format("YYYY-MM-DD HH:mm:ss"),
    };

    let filter = "";
    for (const [, [key, value]] of Object.entries(
      Object.entries(filterItems)
    )) {
      if (value !== "" && eventType !== undefined && eventType !== null) {
        filter += `&${key}=${value}`;
      }
    }
    setExportData({ ...exportData, filter: filterItems });

    if (tab === "new") {
      axios(
        axiosOptions(
          "GET",
          `lpr/events?page_number=${currentPageNumber}&page_size=${rowsPerPage}${filter}`
        )
      )
        .then((response) => {
          setIsLoading(false);
          const {
            data: { data: lprTransactionReportData, total: totalEntries },
          } = response;
          setlprReport(lprTransactionReportData);
          setTotalEntries(totalEntries);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    } else {
      axios(
        axiosOptions(
          "GET",
          `lpr/events/archived?page_number=${currentPageNumber}&page_size=${rowsPerPage}${filter}`
        )
      )
        .then((response) => {
          setIsLoading(false);
          const {
            data: { data: lprTransactionReportData, total: totalEntries },
          } = response;
          setlprReport(lprTransactionReportData);
          setTotalEntries(totalEntries);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }
  };

  React.useEffect(() => {
    if (filterDateRange.isLoading || filterDateRange.isFetching) return;
    doFilter();
  }, [
    crossTimeFrom,
    crossTimeTo,
    currentPageNumber,
    rowsPerPage,
    eventType,
    updateKey,
    searchQueryString,
  ]);

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
  };
  const getEvent = (mode) => {
    if (mode.mode === "plate") {
      onPictureClick(
        mode.lprReport.plate_no_pic_uri,
        "Plate No",
        mode.lprReport.is_images_uploaded &&
          mode?.lprReport?.plate_no_pic_uri &&
          typeof mode.lprReport.plate_no_pic_uri === "string" &&
          mode.lprReport.plate_no_pic_uri !== ""
          ? true
          : false
      );
    }
  };
  const columns = [
    {
      name: "Plate No.",
      selector: (lprReport) => lprReport?.plate_no,
      minWidth: "200px",
      sortable: true,
      cell: (lprReport) => (
        <ProfileCard
          data={lprReport}
          mode="lprReport"
          actions={{}}
          fields={[
            {
              name: "Plate No.",
              value: formatTextWithFallback(lprReport?.plate_no),
            },
            {
              name: "Event Time",
              value: (
                <span className="text-lowercase">
                  {getFormattedDateTime(lprReport?.cross_time)}
                </span>
              ),
            },
            {
              name: "Vehicle Type ",
              value: formatTextWithFallback(lprReport?.vehicle_type),
            },
            {
              name: "Entrance ",
              value: formatTextWithFallback(lprReport?.entrance_name),
            },

            {
              name: "Event Type",
              value: formatTextWithFallback(
                eventTypeMapper(lprReport?.event_type)
              ),
            },
          ]}
          actionsToParent={{}}
        />
      ),
    },

    {
      name: "Vehicle Type",
      minWidth: "200px",
      selector: (lprReport) => lprReport?.vehicle_type,
      sortable: false,
      hide: "md",
      cell: (lprReport) => formatTextWithFallback(lprReport?.vehicle_type),
    },

    {
      name: "Entrance",
      minWidth: "200px",
      selector: (lprReport) => lprReport?.entrance_name,
      sortable: false,
      hide: "md",
      cell: (lprReport) => formatTextWithFallback(lprReport?.entrance_name),
    },

    {
      name: "Event Type",
      minWidth: "200px",
      selector: (lprReport) => lprReport?.event_type,
      sortable: false,
      hide: "md",
      cell: (lprReport) =>
        formatTextWithFallback(eventTypeMapper(lprReport?.event_type)),
    },
    {
      name: "Event Time",
      minWidth: 200,
      hide: "md",
      selector: (lprReport) => lprReport?.cross_time,
      cell: (staff) => getFormattedDateTime(staff?.cross_time),
    },
  ];

  const onChangePage = (page) => {
    setCurrentPageNumber(page);
  };

  const onSearchInputChange = (searchQuery) => {
    setSearchQueryString(searchQuery);
    // doFilter();
  };

  const onChangeRowsPerPage = (rows) => {
    setToStorage({ lpr_report_rows_per_page: rows }, true);
    removeFromStorage();
    setRowsPerPage(rows);
  };

  const closeReportSuccessPopup = () => {
    setShowSuccessModal(false);
    setShowSuccessMessage("");
  };
  const showFilter = (mode) => {
    setShowMobileDataFilter(mode);
  };
  const handleCloseDialog = () => {
    setShowDialog(false);
    setDialogContent(null);
    setDialogTitle(null);
  };
  function imageDialogContentGenVehicle(data, n, f) {
    let imageSrc = data;

    return (
      <div className="d-flex justify-content-center align-items-center">
        <img
          src={f ? imageSrc : noPreview}
          alt={n ?? ""}
          height={f ? "100%" : "150px"}
        />
      </div>
    );
  }
  const onPictureClick = (e, n, f) => {
    setDialogTitle(n);

    setDialogContent(imageDialogContentGenVehicle(e, n, f));

    setShowDialog(true);
  };

  const manageTabs = (t) => {
    setTab(t);
    setResetPagination(true);
    setSearchQueryString("");
    removeFromStorage("lpr_report_filter_search");
    removeFromStorage("lpr_report_filter_event_type");
    onResetInitiated(t);
  };

  return (
    <>
      <ModalComponent
        showSubmit={true}
        content={dialogContent}
        header={dialogTitle}
        show={showDialog}
        hideCancel
        onSubmitCallback={handleCloseDialog}
        onCloseCallback={handleCloseDialog}
        submitButtonText="Close"
      />
      <div className="row">
        <div className="col-12">
          <div className="page-header">
            <div className="d-flex w-100 justify-content-between">
              <div>
                <h1>ANPR Event Report</h1>
              </div>
              <div
                className="tableFilterButton"
                title="Advance Search"
                onClick={() => showFilter(true)}
              >
                <i className="iconsminds-filter-2"></i>
              </div>
            </div>
            <div className="d-flex  w-100 report justify-content-between justify-content-md-end">
              <div>
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <span
                      className={`nav-link ${tab === "new" ? "active" : ""}`}
                      aria-current="page"
                      onClick={(e) => manageTabs("new")}
                    >
                      Recent Events
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className={`nav-link ${tab === "old" ? "active" : ""}`}
                      aria-current="page"
                      onClick={(e) => manageTabs("old")}
                    >
                      Archived Events
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="ReportFilterHolder">
            <div
              className={
                showMobileDataFilter ? "table-filter active" : "table-filter"
              }
            >
              <div
                className="filter-hide"
                onClick={() => showFilter(false)}
              ></div>
              <div className="filter-form">
                <h4>Advanced Search</h4>
                <div className="reportSearch">
                  <LPREventReportFilter
                    key={`filter-${tab}-${filterResetKey}`}
                    filterDateRange={filterDateRange?.data}
                    oncrossTimeFromChange={setcrossTimeFrom}
                    onEventTypeChange={setEventType}
                    handleUpdateKey={handleUpdateKey}
                    loading={filterDateRange?.isLoading}
                    oncrossTimeToChange={setcrossTimeTo}
                    setUpdateKey={setUpdateKey}
                    exportData={exportData}
                    onSearchInputChange={onSearchInputChange}
                    onResetInitiated={() => handleTabChange(tab)}
                    setResetPagination={setResetPagination}
                    buttonVisibility={disableExport}
                    tab={tab}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 mb-4">
          <div className="card">
            <div
              className={`hasStickLastColumn hasStickyAction
                ${
                  isLoading
                    ? "card-body remove-header dataTableOuter reportTable table-loader"
                    : "card-body remove-header dataTableOuter reportTable"
                }`}
            >
              <DataTable
                subHeader={true}
                progressPending={isLoading}
                progressComponent={<p>&nbsp;</p>}
                columns={columns}
                data={lprReport}
                customStyles={customStyles}
                paginationServer={true}
                striped={true}
                onChangePage={onChangePage}
                onChangeRowsPerPage={onChangeRowsPerPage}
                pagination={true}
                paginationPerPage={rowsPerPage}
                paginationTotalRows={totalEntries}
                paginationResetDefaultPage={resetPagination}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={`reportStatusPopup ${showSuccessModal ? "show" : ""}`}>
        <div className="popUp">
          <div className="content">{showSuccessMessage}</div>
          <div className="action">
            <button
              className="btn btn-secondary"
              onClick={closeReportSuccessPopup}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LPRTransactionReport;
